import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=2888f0ce"
import script from "./UserEditDialog.vue?vue&type=script&lang=js"
export * from "./UserEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports